import { UnitOccupation } from '../../enums/unit-bank-account/UnitOccupation.enum';
import { UnitRevenue } from '../../enums/unit-bank-account/UnitRevenue.enum';
import { UnitSourceOfIncome } from '../../enums/unit-bank-account/UnitSourceOfIncome.enum';
import { UnitAddress } from './UnitAddress.model';
import { UnitFullName } from "./UnitFullName.model";
import { UnitPhone } from "./UnitPhone.model";

export class UnitOfficer {
  /// One of Approved, Denied or PendingReview.
  public status: string;

  /// Full name of the officer.
  public fullName: UnitFullName;

  /// One of CEO, COO, CFO or President.
  public title: string;

  /// SSN of the officer (numbers only). One of ssn or passport is required.
  public ssn: string;

  /// Passport of the officer. One of ssn or passport is required.
  public passport: string;

  /// Only when Passport is populated. Two letters representing the officer's nationality.
  public nationality: string;

  public dateOfBirth: Date;

  /// The officer's address.
  public address: UnitAddress;

  /// The officer's phone number.
  public phone: UnitPhone;

  /// The officer's email address.
  public email: string;

  public occupation: UnitOccupation;
  public annualIncome: UnitRevenue;
  public sourceOfIncome: UnitSourceOfIncome;
}
